export enum JurisdictionStatus {
  Active = 'active',
  Inactive = 'inactive',
  Waitlist = 'waitlist'
}

export interface Jurisdiction {
  id: string;
  name: string;
  active_on: string | null;
  status: JurisdictionStatus | null;
}
